<template>
    <el-table
        :data="propsTableData"
        style="width: 100%"
        height="450"
        class="table-wrap ">
        <el-table-column
            prop="ghrq"
            label="预约日期"
            align="center"
            width="120">
        </el-table-column>
        <!--:formatter="dateFilter"-->
        <el-table-column
            prop="numno"
            label="预约号"
            align="center"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            prop="numtime"
            label="预估就诊时间"
            align="center"
            width="120">
        </el-table-column>
        <el-table-column
            prop="hzxm"
            label="患者"
            align="center">
        </el-table-column>
        <el-table-column
            prop="hosPatid"
            label="病案号"
            align="center"
            show-overflow-tooltip>
        </el-table-column>
        <el-table-column
            prop="sjh"
            label="手机号"
            align="center"
            show-overflow-tooltip>
        </el-table-column>

        <el-table-column
            prop="ksmc"
            label="预约科室"
            align="center"
            show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
            prop="ysmc"
            label="预约医生"
            align="center">
        </el-table-column>
        <el-table-column
            prop="operation"
            label="操作"
            align="center"
            class="table-column"
            width="180">
            <template slot-scope="scope">
                <div class="table-btn-wrap">
                    <el-button
                        size="small"
                        @click="linkToDetail(scope.row)"
                        class="table-btn ghost-btn">
                        查看资料
                    </el-button>
                    <!--<el-button-->
                    <!--size="small"-->
                    <!--type="primary"-->
                    <!--@click="linkToDeal($index, row)"-->
                    <!--class="table-btn operate">-->
                    <!--处理-->
                    <!--</el-button>-->
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>
<style>

</style>
<script>
  import {formatUnixTime} from "../../utils/DateFormat.js"

  export default {
    props: ["propsTableData"],
    components: {},
    methods: {
      formatUnix: function (row, column) {//格式化时间格式

        if (row.numdate) {
          return formatUnixTime(row.numdate, "yyyy-MM-dd HH:mm");
        }
      },
      dateFilter(row, column) {
        if (row.numdate) {
          return row.numdate.substring(0, 4) + '-' + row.numdate.substring(4, 6) + '-' + row.numdate.substring(6, 8)
        }
      },
      status(row, column) {//根据服务器获取到的0或1显示订单状态
        switch (row.ddzt) {// 0 未完成   1挂号成功   2 已就诊  3 未就诊  4已退号（5分钟未支付）,5挂号失败,6 医院退号失败，7已取消（5分钟未支付），8退款失败,9进入诊间  -4停诊
          case '0':
            return "未完成";
            break;
          case '1':
            return "挂号成功";
            break;
          case '2':
            return "已就诊";
            break;
          case '3':
            return "未就诊";
            break;
          case '4':
            return "已退号";
            break;
          case '5':
            return "挂号失败";
            break;
          case '6':
            return "医院退号失败";
            break;
          case '7':
            return "已取消";
            break;
          case '8':
            return "退款失败";
            break;
          case '9':
            return "进入诊间";
            break;
          case '-4':
            return "停诊";
            break;
        }
      },
      linkToDetail(row) {

        // return
        this.$router.push({name: 'ClinicDetail', params: {id: row.ddid}})
      }
    }
  }
</script>
